export enum StepState {
  ACTIVE = "active",
  DONE = "done",
  LOCKED = "locked",
}
